<template>
  <Tag
    :label="displayLabel"
    :clickable="true"
    :removable="canDelete"
    @click="handleClick"
    @remove="confirmDelete"
  >
    <template #prefix>
      <span
        class="min-w-4 min-h-4 rounded-full px-0.5 text-white flex items-center justify-center text-[10px] tracking-tighter"
        :style="{ backgroundColor: tagColor }"
      >{{ tagRelationshipCount > 1 ? tagRelationshipCount : '' }}</span>
    </template>
  </Tag>

  <!-- Modal Popup using DataTreeViewer -->
  <div
    v-if="showTagModal"
    class="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-5"
  >
    <div class="bg-white rounded shadow-lg p-4 max-w-lg w-full max-h-full overflow-auto">
      <div class="flex justify-between items-center">
        <span class="font-semibold flex items-center" >
          <div
            class="min-w-4 min-h-4 circle mr-2"
            :style="{ backgroundColor: tagColor }"
          ></div>
          <span v-if="tagType" class="text-gray-500 me-1">{{ tagType }}:</span>
          {{ tagName }}
        </span>
        <button class="text-gray-600 text-2xl" @click="closeDataTreeModal">&times;</button>
      </div>
      <div v-for="tagRelationship in sortedTagRelationships" :key="tagRelationship.key">
        <TagBadge_Relationship_Detail :tag-relationship="tagRelationship" :expand-details="tagRelationship.entity === entityId"  />
      </div>
    </div>
  </div>

  <ConfirmationModal
    :is-visible="showDeleteConfirm"
    :message="confirmDeleteModalMessage"
    @confirm="executeDelete"
    @cancel="showDeleteConfirm = false"
  />
</template>

<script>
import TagBadge_Relationship_Detail from '@/components/widgetcomponents/TagBadge_Relationship_Detail.vue'
import Tag from '@/components/widgetcomponents/library/Tag.vue'
import ConfirmationModal from '@/components/widgetcomponents/ConfirmationModal.vue'

export default {
  components: {
    TagBadge_Relationship_Detail,
    Tag,
    ConfirmationModal,
  },
  props: {
    entityId: {
      type: [Number, String],
      default: null
    },
    tagName: {
      type: String,
      default: 'No name provided'
    },
    tagType: {
      type: String,
      default: null
    },
    tagColor: {
      type: String,
      default: '#DEDEDE'
    },
    tagRelationships: {
      type: Array,
      default: () => [],
    },
    tagRelationshipCount: {
      type: Number,
      default: null
    },
    canDelete: {
      type: Boolean,
      default: false
    },
  },
  emits: ['delete', 'open'],
  data() {
    return {
      showTagModal: false,
      showDeleteConfirm: false,
    }
  },
  computed: {
    displayLabel() {
      return this.tagType ? `${this.tagType}: ${this.tagName}` : this.tagName;
    },
    combinedName() {
        return `${this.tagType}: ${this.tagName}`
    },
    confirmDeleteModalMessage() {
      return `Are you sure you want to remove ${this.tagRelationshipCount > 1 ? this.tagRelationshipCount + ' instances of ' : ''}the tag "${this.combinedName}"?`;
    },
    sortedTagRelationships() {
      return this.tagRelationships.slice().sort((a, b) => {
        const aHasEntity = a.entity === this.entityId;
        const bHasEntity = b.entity === this.entityId;

        if (aHasEntity && !bHasEntity) return -1;
        if (!aHasEntity && bHasEntity) return 1;
        return 0;
      });
    },
  },
  methods: {
    handleClick() {
      if (this.sortedTagRelationships && this.sortedTagRelationships.length > 0) {
        this.showTagModal = true;
      } else {
        this.$emit('open');
      }
    },
    closeDataTreeModal() {
      this.showTagModal = false
    },
    confirmDelete() {
      this.showDeleteConfirm = true;
    },
    executeDelete() {
      this.showDeleteConfirm = false;
      this.$emit('delete');
    },
  },
}
</script>

<style scoped>
.circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
}
</style>
